import { SVGProps } from "react";

export const TrelloMarkBrandV2 = ({
    width = "100%",
    height = "100%"
}: Pick<SVGProps<SVGSVGElement>, "height" | "width">) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Container">
            <path
                id="icon"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.9431 5H7.68689C6.97395 5.00096 6.29054 5.28485 5.78676 5.78931C5.28297 6.29378 5.00001 6.97757 5.00001 7.69051V24.925C4.99906 25.2786 5.06782 25.6289 5.20238 25.956C5.33694 26.283 5.53464 26.5803 5.78419 26.8309C6.03374 27.0814 6.33023 27.2803 6.65671 27.4162C6.9832 27.5521 7.33326 27.6223 7.68689 27.6227H24.9431C25.2967 27.6223 25.6468 27.5521 25.9733 27.4162C26.2998 27.2803 26.5963 27.0814 26.8458 26.8309C27.0954 26.5803 27.2931 26.283 27.4276 25.956C27.5622 25.6289 27.6309 25.2786 27.63 24.925V7.69051C27.63 6.97757 27.347 6.29378 26.8432 5.78931C26.3395 5.28485 25.656 5.00096 24.9431 5ZM14.754 21.299C14.7535 21.4167 14.7297 21.5332 14.684 21.6417C14.6383 21.7502 14.5716 21.8486 14.4876 21.9312C14.4037 22.0138 14.3042 22.079 14.195 22.1229C14.0857 22.1669 13.9689 22.1888 13.8511 22.1873H10.0801C9.84378 22.1873 9.61706 22.094 9.44931 21.9276C9.28155 21.7612 9.18635 21.5352 9.18443 21.299V10.0583C9.18539 9.82139 9.28018 9.59451 9.44804 9.42733C9.61589 9.26016 9.84315 9.16629 10.0801 9.1663H13.8511C13.9692 9.16486 14.0863 9.18686 14.1958 9.23105C14.3053 9.27523 14.4049 9.34071 14.4889 9.42368C14.5729 9.50665 14.6396 9.60547 14.6851 9.71441C14.7306 9.82335 14.754 9.94024 14.754 10.0583V21.299ZM23.4564 16.1464C23.4555 16.264 23.4314 16.3803 23.3855 16.4886C23.3396 16.5969 23.2728 16.6951 23.189 16.7776C23.1052 16.8601 23.0059 16.9252 22.8969 16.9694C22.7878 17.0135 22.6712 17.0357 22.5536 17.0348H18.7789C18.5423 17.0348 18.3154 16.9408 18.1481 16.7735C17.9809 16.6062 17.8869 16.3793 17.8869 16.1428V10.0583C17.8869 9.82172 17.9809 9.59484 18.1481 9.42756C18.3154 9.26027 18.5423 9.1663 18.7789 9.1663H22.5536C22.6715 9.16534 22.7884 9.18768 22.8977 9.23203C23.007 9.27639 23.1064 9.34188 23.1903 9.42476C23.2742 9.50764 23.3409 9.60627 23.3865 9.71499C23.4322 9.82371 23.456 9.94037 23.4564 10.0583V16.1464Z"
                fill="url(#paint0_linear_1273_1237)"
            />
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_1273_1237"
                x1="16.3259"
                y1="27.6227"
                x2="16.3259"
                y2="5"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#0052CC" />
                <stop offset="1" stopColor="#2684FF" />
            </linearGradient>
        </defs>
    </svg>
);
